/**
 * SP フッターmenuの高さをhtmlタグに付与
 */
function setFooterFloatMenuHeight() {
  const footerFloatMenu = document.querySelector('.hb-js-footer-float-menu');
  if(!footerFloatMenu) {
    return
  }
  document.documentElement.style.setProperty('--footer-float-menu', `${footerFloatMenu.offsetHeight}px`);
}
setFooterFloatMenuHeight();

const footerFloatMenuMediaQuery = window.matchMedia("(max-width: 989px)");
footerFloatMenuMediaQuery.addEventListener("change", setFooterFloatMenuHeight);
/**
 * END SP フッターmenuの高さをhtmlタグに付与
 */

/**
 * メール フッターのお問い合わせから遷移してきた際、
 * TOPページでチャネルトークを起動する
 */
window.addEventListener('load', () => {
  if (!document.body.classList.contains("template-index")) return;
  
  const urlQuery = window.location.search;
  const pattern = /[?&]openChannelIO\b/;
  const shouldChannelIOApp = pattern.test(urlQuery);

  if(shouldChannelIOApp) {
    setTimeout(() => {
      window.ChannelIO&&window.ChannelIO("showMessenger");
    }, 600);
  }
})
/**
 * END メール フッター
 */
